const { watch } = require('vue');
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDevicesInfos = exports.ProjectService = exports.AUTO_SAVE_STATE = void 0;
const tslib_1 = require("tslib");
const model_1 = require("@/model");
const work_1 = require("@/store/modules/work");
const api_1 = tslib_1.__importDefault(require("@/api"));
const element_plus_1 = require("element-plus");
const loading_1 = require("@/utils/loading");
const one_message_1 = require("@/utils/one_message");
const user_1 = require("@/service/user");
const router_1 = tslib_1.__importDefault(require("@/router"));
var AUTO_SAVE_STATE;
(function (AUTO_SAVE_STATE) {
    AUTO_SAVE_STATE[AUTO_SAVE_STATE["IDLE"] = 0] = "IDLE";
    AUTO_SAVE_STATE[AUTO_SAVE_STATE["WAITING"] = 1] = "WAITING";
    AUTO_SAVE_STATE[AUTO_SAVE_STATE["SAVING"] = 2] = "SAVING";
    AUTO_SAVE_STATE[AUTO_SAVE_STATE["CHANGED"] = 3] = "CHANGED";
})(AUTO_SAVE_STATE || (exports.AUTO_SAVE_STATE = AUTO_SAVE_STATE = {}));
class ProjectService {
    constructor() {
        this.oldPid = null;
        this.unwatch = null;
        this.curAutoSaveState = AUTO_SAVE_STATE.IDLE;
        this.firstModifyTime = 0;
        this.projectInfo = {
            page_size: 0,
            page: 0,
            page_total: 0,
            total: 0,
            project_infos: []
        };
        this.saveProject = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            var _a;
            if (this.curAutoSaveState != AUTO_SAVE_STATE.WAITING && this.curAutoSaveState != AUTO_SAVE_STATE.SAVING) {
                throw new Error("State error: " + this.curAutoSaveState);
            }
            this.curAutoSaveState = AUTO_SAVE_STATE.SAVING;
            let store = (0, work_1.useWork)();
            if (store.projectSaveState != 'error') {
                store.projectSaveState = 'saving';
            }
            try {
                let res = yield ((_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.saveProject());
                if (res.code === 401) {
                    (0, one_message_1.oneMessage)({
                        message: res.message,
                        type: 'error',
                    });
                }
                if (!this.unwatch)
                    return;
                if (res.code === 1000) {
                    store.projectSaveState = 'saved';
                }
                else {
                    throw new Error(res);
                }
            }
            catch (e) {
                console.error('auto save err', e);
                if (!this.unwatch)
                    return;
                if (store.projectSaveState !== 'error') {
                    store.projectSaveState = 'error';
                    (0, one_message_1.oneMessage)({
                        message: `自动保存发生错误,你可继续编辑，内容将在联网后与云端同步。`,
                        type: 'warning',
                    });
                }
                if (this.curAutoSaveState === AUTO_SAVE_STATE.SAVING) {
                    setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                        if (this.curAutoSaveState === AUTO_SAVE_STATE.SAVING) {
                            this.saveProject();
                        }
                        else if (this.curAutoSaveState === AUTO_SAVE_STATE.CHANGED) {
                            this.waiting();
                        }
                    }), 1000);
                    return;
                }
                console.error(e);
            }
            if (this.curAutoSaveState === AUTO_SAVE_STATE.CHANGED) {
                yield this.waiting();
            }
            else {
                yield model_1.Project.clearProjectCache();
                this.curAutoSaveState = AUTO_SAVE_STATE.IDLE;
            }
        });
        this.waiting = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.curAutoSaveState !== AUTO_SAVE_STATE.IDLE && this.curAutoSaveState !== AUTO_SAVE_STATE.CHANGED)
                throw new Error("State error: " + this.curAutoSaveState);
            this.curAutoSaveState = AUTO_SAVE_STATE.WAITING;
            if (Date.now() - this.firstModifyTime >= ProjectService.SAVE_TIME) {
                this.firstModifyTime = Date.now();
                yield this.saveProject();
            }
            else {
                setTimeout(() => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (this.curAutoSaveState === AUTO_SAVE_STATE.WAITING && this.unwatch)
                        yield this.saveProject();
                }), ProjectService.SAVE_TIME - (Date.now() - this.firstModifyTime));
            }
        });
    }
    static current() {
        if (ProjectService.instance == null) {
            ProjectService.instance = new ProjectService();
        }
        return ProjectService.instance;
    }
    initProjectConflictDialog(projectConflictOpenFun) {
        this.projectConflictOpenFun = projectConflictOpenFun;
    }
    openProjectConflictDialog(remoteTimestamp, localTimestamp) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.projectConflictOpenFun) {
                return yield this.projectConflictOpenFun(remoteTimestamp, localTimestamp);
            }
            else {
                throw new Error('ProjectConflictDialog not init');
            }
        });
    }
    loadProjectData(id) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            (0, loading_1.openLoading)({
                fullscreen: true,
                lock: true,
                text: "正在加载项目数据"
            });
            try {
                this.closeAutoSave();
                let project = model_1.Project.getById(id);
                let store = (0, work_1.useWork)();
                if (project && project.open) {
                    this.startAutoSave();
                    return;
                }
                let isConfirmOpen = true;
                if (store.projectSaveState === 'changed' || store.projectSaveState === 'error' || store.projectSaveState === 'saving') {
                    let saveRes;
                    for (let i = 0; i < 3; i++) {
                        saveRes = yield ((_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.saveProject());
                        if (saveRes.code === 200) {
                            break;
                        }
                    }
                    if (saveRes.code !== 200) {
                        let res = yield element_plus_1.ElMessageBox.confirm('自动保存失败，是否丢弃更改继续切换？', '自动保存', { type: 'warning' });
                        if (res != 'confirm') {
                            this.startAutoSave();
                            return;
                        }
                    }
                }
                if (!project) {
                    let res = yield (0, api_1.default)('project.info', { id });
                    if (res.code === 1000 && res.data) {
                        let remoteProjectData = JSON.parse(res.data.data);
                        remoteProjectData.name = res.data.name;
                        remoteProjectData.version = res.data.version;
                        remoteProjectData.id = res.data.id;
                        remoteProjectData.updateTime = res.data.updateTime;
                        let userInfo = yield (0, user_1.getUserInfo)();
                        let localCache = model_1.Project.getProjectCache(userInfo.username);
                        let needSave = false;
                        if (localCache && remoteProjectData.id === localCache.pid) {
                            let remoteDate = new Date(remoteProjectData.updateTime).getTime();
                            let isOpenLocal = (yield this.openProjectConflictDialog(remoteDate, localCache.timestamp)) === 'local';
                            if (isOpenLocal) {
                                remoteProjectData = localCache;
                                needSave = true;
                            }
                        }
                        project = yield model_1.Project.reduceResProjectData(remoteProjectData);
                        if (needSave && project) {
                            yield project.saveProject();
                        }
                    }
                    else {
                        if (res.code === 401) {
                            (0, one_message_1.oneMessage)({ message: "登录过期，请重新登录", type: "error" });
                        }
                        else {
                            (0, one_message_1.oneMessage)({ message: '加载工程失败', type: 'error' });
                        }
                        throw new Error('load project data failure');
                    }
                }
                if (!project.machines.find(machine => machine.type === model_1.ENTITY_TYPE.ROBOT)) {
                    yield router_1.default.push({ name: 'design' });
                }
                model_1.Project.replace(project);
                if (project.machines.length) {
                    store.selectNode(project.machines[0]);
                }
                this.startAutoSave();
            }
            catch (e) {
                console.log(e);
            }
            finally {
                (0, loading_1.closeLoading)();
            }
        });
    }
    static getProjectById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let project = model_1.Project.getById(id);
            if (project)
                return project;
            let res = yield (0, api_1.default)('project.info', { id });
            if (res.code !== 1000 || !res.data)
                throw new Error('获取工程数据失败！');
            let remoteProjectData = JSON.parse(res.data.data);
            remoteProjectData.name = res.data.name;
            remoteProjectData.version = res.data.version;
            remoteProjectData.id = res.data.id;
            project = yield model_1.Project.reduceResProjectData(remoteProjectData);
            return project;
        });
    }
    openLastOpenProject() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            (0, loading_1.openLoading)({
                fullscreen: true,
                lock: true,
                text: "正在加载项目数据"
            });
            try {
                let projectListRes = yield this.getAllProjectList();
                let projectList = projectListRes === null || projectListRes === void 0 ? void 0 : projectListRes.project_infos;
                if (!projectList || projectList.length === 0) {
                    throw new Error('无工程，请新建！');
                }
                let project = model_1.Project.current();
                let projectId = project === null || project === void 0 ? void 0 : project.id;
                if (!projectId && projectList && projectList.length != 0) {
                    projectId = projectList.reduce((prev, cur) => {
                        if (cur.updateTime > prev.updateTime) {
                            return cur;
                        }
                        return prev;
                    }).pid;
                }
                if (projectId) {
                    yield this.loadProjectData(projectId);
                }
            }
            catch (e) {
                throw e;
            }
            finally {
                (0, loading_1.closeLoading)();
            }
        });
    }
    getAllProjectList() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (this.projectInfo.project_infos.length === 0) {
                yield this.refreshProjects();
            }
            return this.projectInfo;
        });
    }
    refreshProjects() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let res = yield (0, api_1.default)('project.list');
            if (res.code === 1000) {
                let data = res.data;
                console.log(res.data);
                this.projectInfo.project_infos = data.map(item => {
                    return { pid: item.id, p_name: item.name, version: item.version, updateTime: item.updateTime };
                });
            }
            else {
                (0, one_message_1.oneMessage)({
                    type: 'error',
                    message: '获取工程数据失败'
                });
            }
        });
    }
    delProject(pid) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let workStore = (0, work_1.useWork)();
            this.closeAutoSave();
            let res = yield (0, api_1.default)('project.delete', { id: pid });
            if (res.data) {
                try {
                    if (((_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.id) === pid) {
                        model_1.Project.clearProjectCache();
                        workStore.projects.splice(workStore.projects.findIndex(project => project.id === pid), 1);
                        workStore.resetProject();
                    }
                    this.projectInfo.total -= 1;
                    let pInfoIndex = this.projectInfo.project_infos.findIndex(item => item.pid === pid);
                    let pageStartIndex = (this.projectInfo.page - 1) * this.projectInfo.page_size;
                    let pageEndIndex = Math.min(pageStartIndex + this.projectInfo.page_size, this.projectInfo.project_infos.length);
                    for (let i = pageStartIndex; i < pageEndIndex; i++) {
                        if (this.projectInfo.project_infos[i].pid === pid) {
                            this.projectInfo.page_total -= 1;
                            break;
                        }
                    }
                    this.projectInfo.project_infos.splice(pInfoIndex, 1);
                }
                catch (e) {
                    console.log(e);
                }
            }
            else {
                throw new Error('删除失败');
            }
        });
    }
    addProject(project) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let store = (0, work_1.useWork)();
            let res = yield (0, api_1.default)('project.add', { name: project.name, data: JSON.stringify(project.toJson()) });
            if (res.code === 1000) {
                project.id = res.data.id;
                this.projectInfo.project_infos.unshift({
                    pid: project.id,
                    p_name: project.name,
                    file_name: '',
                    add_time: new Date().toDateString(),
                    updateTime: new Date().toDateString()
                });
                store.projects.unshift(project);
                return project;
            }
            else {
                throw new Error(res.message);
            }
        });
    }
    modifyProjectName(id, name) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let project = model_1.Project.current();
            if (id !== (project === null || project === void 0 ? void 0 : project.id)) {
                project = yield ProjectService.getProjectById(id);
            }
            project.name = name;
            if (id !== ((_a = model_1.Project.current()) === null || _a === void 0 ? void 0 : _a.id)) {
                yield project.saveProject();
            }
            let projectList = yield this.getAllProjectList();
            if (projectList) {
                let project = projectList.project_infos.find(project => project.pid === id);
                if (project)
                    project.p_name = name;
            }
        });
    }
    clearCache() {
        this.projectInfo = {
            page_size: 0,
            page: 0,
            page_total: 0,
            total: 0,
            project_infos: []
        };
    }
    startAutoSave() {
        let store = (0, work_1.useWork)();
        if (!this.unwatch) {
            this.unwatch = watch(() => model_1.Project.current(), (newData, oldData) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                if (model_1.Project.current()) {
                    yield model_1.Project.current().saveProjectCache();
                    if (this.curAutoSaveState === AUTO_SAVE_STATE.IDLE) {
                        yield this.waiting();
                    }
                    else if (this.curAutoSaveState === AUTO_SAVE_STATE.SAVING) {
                        this.curAutoSaveState = AUTO_SAVE_STATE.CHANGED;
                        this.firstModifyTime = Date.now();
                    }
                }
            }), {
                deep: true,
                immediate: true
            });
        }
    }
    closeAutoSave() {
        if (this.unwatch) {
            this.unwatch();
            this.unwatch = null;
        }
        let store = (0, work_1.useWork)();
        store.projectSaveState = "";
        this.oldPid = null;
        this.firstModifyTime = 0;
        this.curAutoSaveState = AUTO_SAVE_STATE.IDLE;
    }
    getAutoSaveState() {
        return this.curAutoSaveState;
    }
}
exports.ProjectService = ProjectService;
ProjectService.SAVE_TIME = 1000;
const devicesInfos = [];
const getDevicesInfos = () => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    if (!devicesInfos || devicesInfos.length === 0) {
        let res = yield (0, api_1.default)('devices', null);
        if (res.code === 1000) {
            devicesInfos.push(...res.data);
        }
        else {
            return [];
        }
    }
    return devicesInfos;
});
exports.getDevicesInfos = getDevicesInfos;
function getServeTime() {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        return new Date().getTime();
    });
}
